import { render, staticRenderFns } from "./dialog-dialogpolicyoneid.vue?vue&type=template&id=180c3d2e&"
import script from "./dialog-dialogpolicyoneid.vue?vue&type=script&lang=js&"
export * from "./dialog-dialogpolicyoneid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports